module.exports = __webpack_public_path__ + "img/dcmm.c41378c8.png";